import { useEffect } from "react";

import Typography from '@material-ui/core/Typography';

// const useStyles = makeStyles((_) => ({
//   fieldContainer: {
//     width: "100%",
//     textAlign: "left",
//   },
  
//   uploadInput: {
//     display: "none",
//   },
// }));

export default function OwenAd(props) {
  // const classes = useStyles();
  // const [owenSettings, setOwenSettings] = useState({});

  useEffect(() => {
  }, []);

  return (
    <>
      <Typography variant="h5" color="primary" gutterBottom>
        Owen Payments 
      </Typography>    
      <Typography variant="body1">A startup Owen Payments oferece
      recebimentos via PIX a custo fixo de R$ 0,99 por operação.</Typography>
      <Typography variant="body1">Selecione o gateway de pagamento 
      "Owen Payments 💎" e solicite a abertura da sua conta!</Typography>
    </>
  );
}
